import React, { useCallback, useMemo } from "react";
import ReactSelect from "react-select";
import { Button, Col, Input, Label, Row } from "reactstrap";
import ReactTable from "@dhn/components/molecules/data-table";
import ButtonEnabled from "../../../../../../../../../@dhn/components/molecules/button-enabled";
import { buildAuth0Username } from "../../../../../../utils/auth0-username";

export default function User({
  onChange,
  isMedical,
  dataUserSelected,
  profileSelected,
  profileOptions,
  getMedicalByBranch,
  validationAtLeastOneDoctor,
  validationAtleastOneDoctorActive,
  isNew,
}) {
  const optionsFilterData = getMedicalByBranch?.filter(
    (item) =>
      !dataUserSelected?.doctorSecretary?.some(
        (itemDetail) =>
          !itemDetail?.wasEliminated &&
          itemDetail?.medicalStaffId === item?.medicalStaffId
      )
  );

  const actionsChangeStatus = useCallback(
    (medicalStaffId, status) => {
      if (!status && validationAtleastOneDoctorActive()) return;

      const dataChangeStatus = dataUserSelected?.doctorSecretary?.map(
        (item) => ({
          ...item,
          enabled:
            item?.medicalStaffId === medicalStaffId ? status : item.enabled,
        })
      );

      onChange("doctorSecretary", dataChangeStatus, "userSelected");
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      // eslint-disable-next-line react-hooks/exhaustive-deps
      dataUserSelected?.doctorSecretary,
      onChange,
      validationAtleastOneDoctorActive,
    ]
  );

  const removeDoctor = useCallback(
    (medicalStaffId, status) => {
      if (validationAtLeastOneDoctor()) return;
      if (status && validationAtleastOneDoctorActive()) return;

      const doctorRemoved = dataUserSelected?.doctorSecretary?.map((item) => ({
        ...item,
        wasEliminated:
          item?.medicalStaffId === medicalStaffId ? status : item.wasEliminated,
      }));

      onChange("doctorSecretary", doctorRemoved, "userSelected");
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      // eslint-disable-next-line react-hooks/exhaustive-deps
      dataUserSelected?.doctorSecretary,
      onChange,
      validationAtLeastOneDoctor,
      validationAtleastOneDoctorActive,
    ]
  );

  const profileValue = useMemo(
    () =>
      (profileOptions || []).find(
        (item) => Number(item?.id) === Number(profileSelected?.id),
      ) || null,
    [profileOptions, profileSelected],
  );

  return (
    <div className="animated fadeIn">
      <Row form className="my-2">
        <Col>
          <Label>Nombres:</Label>
          <Input
            disabled={!isMedical}
            onChange={({ target: { value } }) => {
              onChange("firstName", value, "userSelected");
              if (isNew) {
                onChange(
                  "username",
                  buildAuth0Username(
                    value,
                    dataUserSelected?.lastName,
                    dataUserSelected?.identification,
                  ),
                  "userSelected",
                );
              }
            }}
            value={dataUserSelected?.firstName || ""}
            placeholder="Escribir Nombres"
          />
        </Col>

        <Col>
          <Label>Apellidos:</Label>
          <Input
            disabled={!isMedical}
            value={dataUserSelected?.lastName || ""}
            placeholder="Escribir Apellidos"
            onChange={({ target: { value } }) => {
              onChange("lastName", value, "userSelected");
              if (isNew) {
                onChange(
                  "username",
                  buildAuth0Username(
                    dataUserSelected?.firstName,
                    value,
                    dataUserSelected?.identification,
                  ),
                  "userSelected",
                );
              }
            }}
          />
        </Col>
      </Row>

      <Row form className="d-flex align-items-end">
        <Col>
          <Label>{"Perfil:"}</Label>
          <ReactSelect
            placeholder="Seleccionar perfil"
            isDisabled={!isMedical}
            className="w-100"
            getOptionLabel={(item) => item.name}
            getOptionValue={(item) => item}
            options={profileOptions}
            value={profileValue}
            onChange={(selectedProfile) => {
              onChange("profileSelected", selectedProfile);
              onChange("profileId", selectedProfile?.id || null, "userSelected");
              onChange("profile", selectedProfile || null, "userSelected");
            }}
          />
        </Col>
        <Col>
          <Label>Correo Electrónico:</Label>
          <Input
            disabled={!isMedical}
            onChange={({ target: { value } }) =>
              onChange("email", value?.trim(), "userSelected")
            }
            value={dataUserSelected?.email?.trim() || ""}
            placeholder="Escribir Correo Electrónico"
          />
        </Col>
      </Row>

      <Row className="my-2" form>
        <Col>
          <Label> No. de Indentificación: </Label>
          <Input
            className="mr-2"
            value={dataUserSelected?.identification || ""}
            placeholder="Documento"
            disabled
          />
        </Col>
        <Col>
          <Label>Usuario:</Label>
          <Input
            disabled
            value={dataUserSelected?.username || ""}
            placeholder="Usuario"
          />
        </Col>
      </Row>

      <Row form hidden={isMedical ? false : true} className="my-2">
        <Col md={6}>
          <Label>Medico:</Label>
          <ReactSelect
            options={optionsFilterData || []}
            getOptionLabel={(item) => item.medicalStaffName}
            getOptionValue={(item) => item}
            value={null}
            placeholder="Seleccionar medico"
            onChange={({ doctorSecretaryId, ...item }) => {
              if (
                dataUserSelected?.doctorSecretary?.some(
                  (itm) => itm?.medicalStaffId === item?.medicalStaffId
                )
              ) {
                onChange(
                  "doctorSecretary",
                  [
                    ...(dataUserSelected?.doctorSecretary?.map((item2) =>
                      item2?.medicalStaffId === item?.medicalStaffId
                        ? {
                            ...item2,
                            wasEliminated: false,
                            ...(doctorSecretaryId
                              ? { id: doctorSecretaryId }
                              : {}),
                          }
                        : item2
                    ) || []),
                  ],
                  "userSelected"
                );
                return;
              }

              onChange(
                "doctorSecretary",
                [
                  ...(dataUserSelected?.doctorSecretary || []),
                  {
                    ...item,
                    userId: dataUserSelected?.id,
                    enabled: true,
                    wasEliminated: false,
                    ...(doctorSecretaryId ? { id: doctorSecretaryId } : {}),
                  },
                ],
                "userSelected"
              );
            }}
          />
        </Col>
      </Row>

      <Row form hidden={isMedical ? false : true}>
        <Col>
          <Label>Medicos Asignados:</Label>
          <ReactTable
            defaultPageSize={5}
            data={
              dataUserSelected?.doctorSecretary?.filter(
                (item) => !item?.wasEliminated
              ) || []
            }
            noDataText="No hay Medicos agregados"
            columns={useMemo(
              () => [
                {
                  Header: "Medico",
                  accessor: "medicalStaffName",
                },
                {
                  Header: "Especialidad",
                  accessor: "nameSpeciality",
                },
                {
                  Header: "Opciones",
                  Cell: ({ original }) => {
                    return (
                      <div>
                        <ButtonEnabled
                          status={original?.enabled}
                          onClick={() =>
                            actionsChangeStatus(
                              original?.medicalStaffId,
                              !original?.enabled
                            )
                          }
                        />
                        <Button
                          color={"danger"}
                          disabled={original?.wasEliminated}
                          className="btn-color-danger py-0 px-1 ml-1"
                          onClick={() =>
                            removeDoctor(original?.medicalStaffId, true)
                          }
                        >
                          <i className={"fa fa-trash"} />
                          {"  Borrar"}
                        </Button>
                      </div>
                    );
                  },
                },
              ],
              [actionsChangeStatus, removeDoctor]
            )}
          />
        </Col>
      </Row>
    </div>
  );
}
